export default "__VITE_ASSET__BEtIU2Z8__"